export default __webpack_public_path__ + "static/6-bf6eaefa99213fd6c4fc1949f6988166.jpg";